"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _EspSyncModal = _interopRequireDefault(require("./EspSyncModal"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIMultiColumn = _interopRequireDefault(require("UIComponents/layout/UIMultiColumn"));

var _UIMultiColumnGroup = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnGroup"));

var _UIMultiColumnItem = _interopRequireDefault(require("UIComponents/layout/UIMultiColumnItem"));

var _EmailServiceProvider = require("lead-flows-ui/constants/EmailServiceProvider");

var _Strings = require("lead-flows-ui/constants/Strings");

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

function pluralize(number, singular, plural) {
  plural = plural || singular + "s";
  return parseInt(number, 10) === 1 ? singular : plural;
}

var _default = _react.default.createClass({
  displayName: "EmailServiceProviderStatus",
  propTypes: {
    fetching: _react.default.PropTypes.bool.isRequired,
    fetchingHasError: _react.default.PropTypes.bool.isRequired,
    fetchingRecentError: _react.default.PropTypes.object,
    espType: _react.default.PropTypes.string.isRequired,
    espConnectionStatus: _react.default.PropTypes.string.isRequired,
    espSubscriptionsCount: _react.default.PropTypes.number.isRequired,
    formGuid: _react.default.PropTypes.string.isRequired,
    isCrmUser: _react.default.PropTypes.bool.isRequired
  },
  contextTypes: {
    store: _react.default.PropTypes.object.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      showAlert: true,
      isModalOpened: false
    };
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowOptionsEditor.emailServiceProviderStatus." + suffix;
  },
  toggleAlert: function toggleAlert() {
    this.setState({
      showAlert: false
    });
  },
  openListsModal: function openListsModal() {
    this.setState({
      isModalOpened: true
    });
  },
  closeListsModal: function closeListsModal() {
    this.setState({
      isModalOpened: false
    });
  },
  maybeRenderEspListModal: function maybeRenderEspListModal(isModalOpened, formGuid, espType) {
    var component;

    if (isModalOpened) {
      component = _react.default.createElement(_EspSyncModal.default, {
        formGuid: formGuid,
        espName: _Strings.ESP_TYPES[espType],
        onConfirm: this.closeListsModal,
        onReject: this.closeListsModal
      });
    }

    return component;
  },
  renderEspContent: function renderEspContent(espType, espConnectionStatus) {
    var content;

    if (espType === _EmailServiceProvider.ESP_TYPES.NONE || espConnectionStatus === _Strings.ESP_CONNECTION_STATUS.NOT_CONNECTED) {
      content = _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('noEmailProviderEnabled')
      });
    } else {
      var espName = _Strings.ESP_TYPES[espType];

      if (espConnectionStatus === _Strings.ESP_CONNECTION_STATUS.CONNECTED) {
        content = _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('pushContactsTo'),
          options: {
            espName: espName
          }
        });
      } else {
        content = _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('pushConnectionBroken'),
          options: {
            espName: espName
          }
        });
      }
    }

    return _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, null, content), _react.default.createElement(_UIMultiColumnItem.default, null, _react.default.createElement(_UIButton.default, {
      size: "small",
      use: "tertiary-light",
      href: (0, _RouteGenerators.getSettingsRoute)(),
      target: "_blank"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('manageInSettings')
    }))));
  },
  renderEspListContent: function renderEspListContent(espType, espConnectionStatus, espSubscriptionsCount) {
    var content;

    if (espType !== _EmailServiceProvider.ESP_TYPES.NONE && espConnectionStatus === _Strings.ESP_CONNECTION_STATUS.CONNECTED) {
      var espName = _Strings.ESP_TYPES[espType];

      if (espSubscriptionsCount > 0) {
        var list = pluralize(espSubscriptionsCount, 'list');
        content = _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('pushNewContactsTo'),
          options: {
            espSubscriptionsCount: espSubscriptionsCount,
            espName: espName,
            list: list
          }
        });
      } else {
        content = _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('noListsSelected'),
          options: {
            espName: espName
          }
        });
      }
    }

    return content ? _react.default.createElement(_UIMultiColumnGroup.default, null, _react.default.createElement(_UIMultiColumnItem.default, null, content), _react.default.createElement(_UIMultiColumnItem.default, null, _react.default.createElement(_UIButton.default, {
      size: "small",
      onClick: this.openListsModal,
      use: "tertiary-light"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('selectLists')
    })))) : null;
  },
  renderLoadingComponent: function renderLoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true
    });
  },
  renderErrorComponent: function renderErrorComponent(fetchingRecentError) {
    return _react.default.createElement("div", {
      className: "esp-status--error"
    }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
      message: 'thereWasAnError'
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('details')
    }), _react.default.createElement("pre", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('fetchingRecentError'),
      options: {
        fetchingRecentError: fetchingRecentError
      }
    }))));
  },
  render: function render() {
    var _this$props = this.props,
        fetching = _this$props.fetching,
        fetchingHasError = _this$props.fetchingHasError,
        fetchingRecentError = _this$props.fetchingRecentError,
        espType = _this$props.espType,
        espConnectionStatus = _this$props.espConnectionStatus,
        espSubscriptionsCount = _this$props.espSubscriptionsCount,
        formGuid = _this$props.formGuid;
    var isModalOpened = this.state.isModalOpened;

    if (fetching) {
      return this.renderLoadingComponent();
    }

    if (fetchingHasError) {
      return this.renderErrorComponent(fetchingRecentError);
    }

    var espTypeContent = this.renderEspContent(espType, espConnectionStatus);
    var espListContent = this.renderEspListContent(espType, espConnectionStatus, espSubscriptionsCount);
    var maybeEspListModal = this.maybeRenderEspListModal(isModalOpened, formGuid, espType);
    return _react.default.createElement("div", {
      className: "esp-status"
    }, _react.default.createElement(_UIMultiColumn.default, null, espTypeContent, espListContent), maybeEspListModal);
  }
});

exports.default = _default;
module.exports = exports.default;